// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-sidebar {
  position: fixed;
  left: 0;
  top: 114px; 
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: calc(100vh - 512px);
  z-index: 1001;
  background-color: rgba(250, 248, 245, 0.9);
  padding: 10px;
  border-radius: 0 8px 8px 0;
  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.06);
}

.sidebar-top-buttons {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.sidebar-bottom-buttons {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 5px;
}

.sidebar-button {
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Gabarito", serif;
  border: 1px solid rgba(135, 134, 127, 0.25);
  background-image: linear-gradient(rgb(248 246 244), rgb(230 226 221));
  background-clip: padding-box;
  border-radius: 4px;
  cursor: pointer;
  color: #454545;
  transition: all 0.2s ease;
}

.sidebar-button:hover {
  border-color: rgba(135, 134, 127, 0.5);
  transform: translateY(-1px);
}

.sidebar-button.active {
    background-image: none;
    background-color: #ffffff;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/Table/TableSidebar.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,OAAO;EACP,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,2BAA2B;EAC3B,aAAa;EACb,0CAA0C;EAC1C,aAAa;EACb,0BAA0B;EAC1B,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;EAC9B,2CAA2C;EAC3C,qEAAqE;EACrE,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;AAC7B","sourcesContent":[".table-sidebar {\n  position: fixed;\n  left: 0;\n  top: 114px; \n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: calc(100vh - 512px);\n  z-index: 1001;\n  background-color: rgba(250, 248, 245, 0.9);\n  padding: 10px;\n  border-radius: 0 8px 8px 0;\n  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.06);\n}\n\n.sidebar-top-buttons {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.sidebar-bottom-buttons {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-bottom: 5px;\n}\n\n.sidebar-button {\n  width: 40px;\n  height: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-family: \"Gabarito\", serif;\n  border: 1px solid rgba(135, 134, 127, 0.25);\n  background-image: linear-gradient(rgb(248 246 244), rgb(230 226 221));\n  background-clip: padding-box;\n  border-radius: 4px;\n  cursor: pointer;\n  color: #454545;\n  transition: all 0.2s ease;\n}\n\n.sidebar-button:hover {\n  border-color: rgba(135, 134, 127, 0.5);\n  transform: translateY(-1px);\n}\n\n.sidebar-button.active {\n    background-image: none;\n    background-color: #ffffff;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
